import { styled } from '../utils/stitches.config'
import partnerStyles from '../styles/partners'
import saStyles from '../styles/sa'

export const StyledFunnel = styled('div', {
  display: 'flex',
  flexDirection: 'column',

  '.heading--loading': {
    textAlign: 'center'
  },

  '&.funnel--initialLoading': {
    display: 'flex!important'
  },

  p: {
    fontSize: '31px',
    fontFamily: 'proxima-nova',
    margin: '0 auto 35px',
    textAlign: 'center',
    lineHeight: '36px'
  },

  // Temporary styles to be moved on SA side;
  ...saStyles,
  // END Temporary styles to be moved on SA side

  // Partner styles under #smartadvisor-captivate-funnel
  ...partnerStyles,

  // combine media query styles to avoid overlap
  '@bp0': {
    ...saStyles['@bp0'],
    ...partnerStyles['@bp0']
  },
  '@bp1': {
    ...saStyles['@bp1'],
    ...partnerStyles['@bp1']
  },
  '@bp2': {
    ...saStyles['@bp2'],
    ...partnerStyles['@bp2']
  },
  '@bp3': {
    ...saStyles['@bp3'],
    ...partnerStyles['@bp3']
  },
  '@bp4': {
    ...saStyles['@bp4'],
    ...partnerStyles['@bp4']
  }
})
